import RendimientoProfesionalismo from '../domain/RendimientoProfesionalismo'

export default class GetRendimientoProfesionalismo {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute({ idPersonal, idEvaluacion }) {
    try {
      const [evaluacionDto] = await this.#repository.findById({ idPersonal, idEvaluacion })

      if (!evaluacionDto) {
        throw new Error('No se encontró la evaluación.')
      }

      return RendimientoProfesionalismo.fromDto(evaluacionDto)
    } catch (error) {
      console.log(error)
      throw error
    }
  }
}
